<vue-page-header
  [pageTitle]="'label.retrieveUsername' | translate | async"
  [previousPageTitle]="'title.Login' | translate | async"
  (previousPageButtonClicked)="backToLogin()"
>
</vue-page-header>
<div class="full-width" id="usernameLookupMessages">
  <div class="row">
    <div class="panel-container col-xs-12 col-sm-10 col-sm-push-1">
      <!-- Messages -->
      <vue-server-messages [messages]="messages"></vue-server-messages>
    </div>
  </div>
</div>
<div class="full-width">
  <div class="row">
    <div class="panel-container col-xs-12 col-sm-10 col-sm-push-1">
      <vue-panel [title]="'usernameLookup.identityHeading' | translate | async">
          <ng-container vueStepActiveContent>
            <form class="app-form" novalidate #verifyUserForm="ngForm">
              <vue-control-group
                [label]="'field.firstName' | translate | async"
                widthClass="widest"
                [control]="firstNameInput"
                [formError]="formError"
              >
                <input
                  autocomplete="off"
                  vueAutofocus
                  class="form-control"
                  name="firstNameInput"
                  required
                  #inputElement
                  #firstNameInput="ngModel"
                  [(ngModel)]="verifyDetails.firstName"
                  id="firstNameInput"
                  maxlength="50"
                />
              </vue-control-group>
              <vue-control-group
                [label]="'field.lastName' | translate | async"
                widthClass="widest"
                [control]="lastNameInput"
                [formError]="formError"
              >
                <input
                  autocomplete="off"
                  class="form-control"
                  name="lastNameInput"
                  required
                  #inputElement
                  #lastNameInput="ngModel"
                  [(ngModel)]="verifyDetails.lastName"
                  id="lastNameInput"
                  maxlength="50"
                />
              </vue-control-group>
              <vue-control-group
                [label]="'field.email' | translate | async"
                widthClass="widest"
                [control]="emailInput"
                [formError]="formError"
              >
                <input
                  autocomplete="off"
                  class="form-control"
                  type="email"
                  name="emailInput"
                  required
                  #inputElement
                  #emailInput="ngModel"
                  [(ngModel)]="verifyDetails.email"
                  [pattern]="emailRegex"
                  id="emailInput"
                  maxlength="50"
                />
              </vue-control-group>
              <vue-control-group
                [label]="'field.SiteID' | translate | async"
                widthClass="widest"
                [control]="siteIdInput"
                [formError]="formError"
              >
                <input
                  autocomplete="off"
                  class="form-control"
                  name="siteIdInput"
                  required
                  #inputElement
                  #siteIdInput="ngModel"
                  [(ngModel)]="verifyDetails.siteID"
                  id="siteIdInput"
                  maxlength="50"
                />
              </vue-control-group>
            </form>
            <vue-form-buttons
              [primaryLabel]="'label.retrieveUsername' | translate | async"
              (primaryButtonClicked)="getUserDetails()"
              [defaultLabel]="'label.cancel' | translate | async"
              (defaultButtonClicked)=backToLogin()
              [secondaryLabel]="'label.forgotPassword' | translate | async"
              (secondaryButtonClicked)="forgotPassword()"
              [defaultPosition]="'btn-left'"
            >
            </vue-form-buttons>
          </ng-container>
      </vue-panel>
    </div>
  </div>
</div>
